import { Box, Button, CircularProgress, Typography } from "@material-ui/core";
import { ExitToApp, Info, SupervisorAccount } from "@material-ui/icons";
import React from "react";
import { Link,Redirect } from "react-router-dom";
import GritLogo from "src/assets/grit-leadership-logo-white.svg";
// import LoginForm from "src/shared/components/LoginForm";
import SelectSchoolPage from "src/features/director/SelectSchoolPage";
import { Keyboard } from "@material-ui/icons";
import { buttonOffset } from "../../Home";
import {
  ADMIN_BUTTON_LABEL,
  GRIT_LEADERSHIP_SLOGAN,
  MARKETING_PAGE_LINK_LABEL,
  SIGN_OUT_BUTTON_LABEL,
} from "./constants";
import { useStyles } from "./styles";
import { IHomePageProps } from "./types";
import SignUpForm from "src/shared/components/SignUpForm";

export const HomePage = ({ user, loadingUserInitial }: IHomePageProps) => {
  console.log("loadingUserInitial========>",user)
  const classes = useStyles();
  
  // Clear signup data when arriving at homepage
  React.useEffect(() => {
    sessionStorage.removeItem("newUserDetails");
  }, []);
  
  if(Object.keys(user).length>0){
    if(Object.keys(user).length===1){
      return <Redirect to="/name" />
    }
    
  }

  if(user?.status===false){
    alert("Your Account is locked please contact to your Admin.")
    return <Redirect to="/logout" />
  }
  return (
    <>
      {loadingUserInitial && (
        <Box
          position="absolute"
          left="50%"
          top="50%"
          style={{
            transform: "translate(-50%, -50%)",
          }}
        >
          <CircularProgress className={classes.progressLoader} size="3rem" />
        </Box>
      )}
      {!loadingUserInitial && (
        <>
          {user?.id && (
            <div
              style={{
                alignItems: "center",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                left: 0,
                margin: "1.125rem 10px",
                position: "fixed",
                top: 0,
                width: `calc(100% - ${0.75 * 2}rem)`,
              }}
            >
              <img
                className={classes.headerLogo}
                alt="Grit Logo"
                src={GritLogo}
                draggable={false}
              />
              <div>
                {user.isAdmin && (
                  <Link
                    className={classes.text}
                    to="/admin"
                    style={{ margin: "8px" }}
                  >
                    <Button
                      tabIndex={-1}
                      variant="contained"
                      startIcon={<SupervisorAccount />}
                    >
                      {ADMIN_BUTTON_LABEL}
                    </Button>
                  </Link>
                )}

                <Link
                  className={classes.text}
                  to="/logout"
                  style={{ margin: "8px" }}
                >
                  <Button
                    tabIndex={-1}
                    variant="contained"
                    startIcon={<ExitToApp />}
                  >
                    {SIGN_OUT_BUTTON_LABEL}
                  </Button>
                </Link>
              </div>
            </div>
          )}
          <Box
            position="fixed"
            top="50%"
            left="50%"
            style={{
              transform: "translate(-50%, -50%)",
            }}
          >
            <Box alignItems="center" justifyContent="center">
              {!user?.id ? (
                <Box
                  alignItems="center"
                  borderRadius="8px"
                  display="flex"
                  flexDirection="column"
                  gridGap="1.5rem"
                  justifyContent="space-around"
                  padding="3rem"
                  style={{ backgroundColor: "rgba(0,0,0,0.75)" }}
                >
                  <img
                    className={classes.homeLogo}
                    alt="Grit Logo"
                    src={GritLogo}
                    draggable={false}
                  />
                  <Typography variant="h5" className={classes.slogan}>
                    {GRIT_LEADERSHIP_SLOGAN}
                  </Typography>
                  <Box display="flex" alignItems="center" gridGap="1.5rem">
                    {/* <LoginForm /> */}
                    <Link to="/sign-in">
                                <Button
                                  variant="contained"
                                  color="primary"
                                  // onClick={this.handleGoogleClick}
                                  style={{ marginLeft: buttonOffset }}
                                  startIcon={<Keyboard />}
                                >
                                  Sign into your account
                                </Button>
                              </Link>
                              <SignUpForm/>
                  </Box>
                 
                  <a
                      tabIndex={-1}
                      href="https://gritleadershipea.com"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "inline-block",
                        margin: `0.8rem 0px 0.8rem ${buttonOffset}`,
                        textDecoration: "none",
                      }}
                    >
                      <Button
                        color="secondary"
                        variant="contained"
                        startIcon={<Info />}
                      >
                        {MARKETING_PAGE_LINK_LABEL}
                      </Button>
                    </a>
                </Box>
              ) : (
                <SelectSchoolPage />
              )}
            </Box>
          </Box>
        </>
      )}
    </>
  );
};



// WEBPACK FOOTER //
// ./src/features/home/pages/sub-pages/home-page/HomePage.tsx